import { TestIdDomain } from 'constants/testIds';

const ConditionsTestIdsScope = {
  CONDITION_FORM: 'condition-form',
};

export const ConditionsTestIds = {
  // ConditionsTable
  DOWNLOAD_CSV_BUTTON: `${TestIdDomain.CONDITIONS}.download-csv-button`,
  ADD_BUTTON: `${TestIdDomain.CONDITIONS}.add-button`,

  // ConditionForm
  CONDITION_FORM: `${TestIdDomain.CONDITIONS}.${ConditionsTestIdsScope.CONDITION_FORM}`,
  CONDITION_FORM_SUBMIT_BUTTON: `${ConditionsTestIdsScope.CONDITION_FORM}.submit-button`,

  // ConditionTasksTable
  CONDITION_FORM_ADD_TASK_TYPE_BUTTON: `${ConditionsTestIdsScope.CONDITION_FORM}.add-task-type-button`,
  CONDITION_FORM_REMOVE_TASK_TYPE_BUTTON: `${ConditionsTestIdsScope.CONDITION_FORM}.remove-task-type-button`,
  CONDITION_FORM_TASK_COLLAPSE_EXPAND_BUTTON: `${ConditionsTestIdsScope.CONDITION_FORM}.task-collapse-expand-button`,

  // ConditionForm (inline)
  CONDITION_FORM_CONDITION_NUMBER_INPUT: `${ConditionsTestIdsScope.CONDITION_FORM}.condition-number-input`,
  CONDITION_FORM_MESSAGE_INPUT: `${ConditionsTestIdsScope.CONDITION_FORM}.message-input`,
  CONDITION_FORM_BORROWER_MESSAGE_INPUT: `${ConditionsTestIdsScope.CONDITION_FORM}.borrower-message-input`,
  CONDITION_FORM_SUB_COMPANY_MESSAGE_INPUT: `${ConditionsTestIdsScope.CONDITION_FORM}.sub-company-message-input`,
  CONDITION_FORM_CONDITION_IS_ENABLED_SELECT: `${ConditionsTestIdsScope.CONDITION_FORM}.condition-is-enabled-select`,
  CONDITION_FORM_CONDITION_TASK_TYPE_AUTOCOMPLETE_INPUT: `${ConditionsTestIdsScope.CONDITION_FORM}.condition-task-type-autocomplete`,
  CONDITION_FORM_CONDITION_TASK_TYPE_OPTION: `${ConditionsTestIdsScope.CONDITION_FORM}.condition-task-type-option`,
  CONDITION_FORM_PRIOR_TO_AUTOCOMPLETE_INPUT: `${ConditionsTestIdsScope.CONDITION_FORM}.prior-to-autocomplete`,
  CONDITION_FORM_PRIOR_TO_OPTION: `${ConditionsTestIdsScope.CONDITION_FORM}.prior-to-option`,
  CONDITION_FORM_PROGRAM_LOAN_AUTOCOMPLETE_INPUT: `${ConditionsTestIdsScope.CONDITION_FORM}.program-loan-autocomplete`,
  CONDITION_FORM_PROGRAM_LOAN_OPTION: `${ConditionsTestIdsScope.CONDITION_FORM}.program-loan-option`,
  CONDITION_FORM_SLA_GROUP_AUTOCOMPLETE_INPUT: `${ConditionsTestIdsScope.CONDITION_FORM}.sla-group-autocomplete`,
  CONDITION_FORM_SLA_GROUP_OPTION: `${ConditionsTestIdsScope.CONDITION_FORM}.sla-group-option`,
};
